<template>
  <div>
    <!-- Page Wrapper -->
    <div id="wrapper">
      <!-- Sidebar -->
      <ul
        class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <!-- Sidebar - Brand -->
        <div class="text-center row">
          <div class="col-12">
            <div class="text-white text-user-agent mx-3">{{ user.name }}</div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="sidebar-divider my-0" />

        <!-- Nav Item - Dashboard -->
        <!-- <li :class="['nav-item', 'pt-2', $route.name == 'home' ? 'active': '']">
        <router-link :to="{name: 'home'}" class="nav-link">
          <font-awesome-icon :icon="['fas', 'home']" />
          <span class="font-item-menu">Home</span>
        </router-link>
      </li> -->

        <li :class="['nav-item', $route.name == 'status' ? 'active' : '']">
          <router-link :to="{ name: 'status' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'users']" />
            <span class="font-item-menu">Agents Status</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'callme' ? 'active' : '']">
          <router-link :to="{ name: 'callme' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'phone']" />
            <span class="font-item-menu">Call Me Back</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'reports' ? 'active' : '']">
          <router-link :to="{ name: 'reports' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'file-alt']" />
            <span class="font-item-menu">Reports</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'agents' ? 'active' : '']">
          <router-link :to="{ name: 'agents' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'user']" />
            <span class="font-item-menu">Agents</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'ddis' ? 'active' : '']">
          <router-link :to="{ name: 'ddis' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'phone-alt']" />
            <span class="font-item-menu">DDIs</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'groups' ? 'active' : '']">
          <router-link :to="{ name: 'groups' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'user-cog']" />
            <span class="font-item-menu">Groups</span>
          </router-link>
        </li>

        <li :class="['nav-item', $route.name == 'settings' ? 'active' : '']">
          <router-link :to="{ name: 'settings' }" class="nav-link">
            <font-awesome-icon :icon="['fas', 'cog']" />
            <span class="font-item-menu">Settings</span>
          </router-link>
        </li>

        <li class="nav-item pt-2">
          <a href="/logout" class="nav-link" @click.prevent="logout">
            <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
            <span class="font-item-menu">Logout</span>
          </a>
        </li>
      </ul>
      <!-- End of Sidebar -->

      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content">
          <!-- Topbar -->
          <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <div class="row col-12">
              <div>
                <!-- Topbar Navbar -->
                <form class="form-inline ml-auto float-rigth form-call" v-if="twilioOnline">
                  <li class="nav-incoming pr-0">
                    <select
                      class="custom-select w-100 d-inline"
                      v-model="outCallNumber"
                    >
                      <option
                        :value="number"
                        v-for="number in outNumbers"
                        :key="number"
                      >
                        {{ number }}
                      </option>
                    </select>
                  </li>
                  <li class="nav-incoming">
                    <select
                      class="custom-select w-100 d-inline"
                      v-model="outNumberPrefix"
                      v-if="system != null"
                    >
                      <option :value="country.prefix" v-for="country in system.countries" :key="country.id">{{ country.name }} ({{ country.prefix }})</option>
                    </select>
                  </li>
                  <div class="input-group">
                    <input
                      type="phone"
                      placeholder="Number to call"
                      class="form-control"
                      v-model="callNumber"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        :class="[
                          'btn',
                          isValidCallNumber ? 'btn-success' : 'btn-secondary',
                        ]"
                        :disabled="!isValidCallNumber"
                        @click="startCall"
                      >
                        <font-awesome-icon :icon="['fas', 'phone-alt']" />
                      </button>
                    </div>
                  </div>
                </form>
                <p class="text-offline mt-4 font-weight-bold" v-else>
                  Twilio is offline
                </p>
              </div>
              <div>
                <ul class="navbar-nav" v-if="backendConnOpen">
                  <li v-if="mics" class="nav-incoming">
                    <dropdown-menu v-model="showMicSelector">
                      <button class="btn btn-primary dropdown-toggle">
                        Select mic
                      </button>
                      <div slot="dropdown">
                        <a
                          class="dropdown-item"
                          href="#"
                          v-for="mic in mics"
                          :key="mic.device"
                          @click.prevent="selectMic(mic)"
                        >
                          <span v-if="mic.device == selectedMic.device"
                            >&#10003; </span
                          >{{ mic.label }}
                        </a>
                      </div>
                    </dropdown-menu>
                  </li>
                  <li class="nav-incoming">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch"
                        v-model="available"
                        @change="setAvailability"
                      />
                      <label class="custom-control-label" for="customSwitch"
                        >Incoming Calls</label
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <!-- End of Topbar -->

          <!-- Begin Page Content -->
          <legend-menu :groups="system.groups" v-if="system"></legend-menu>
          <alert-new-version v-if="shouldUpgrade"></alert-new-version>
          <router-view />
          <!-- End of Page Content -->
        </div>
        <!-- End of Main Content -->

        <!-- Footer -->
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <p class="font-weight-bold h5">PABX {{ appVersion }}</p>
              <span v-if="commit">Build: {{ commit }}</span>
              <span>Copyright &copy; iTravelMix 2020</span>
            </div>
          </div>
        </footer>
        <!-- End of Footer -->
      </div>
      <!-- End of Content Wrapper -->
    </div>
    <!-- End of Page Wrapper -->

    <!-- Incoming Calls Modal-->
    <IncomingCallDialog
      :title="incomingCallTitle"
      :body="incomingCallBody"
      :user="incomingCallUser"
      @accept_incoming_call="acceptCall"
      @reject_incoming_call="rejectCall"
      v-if="modal == 'incoming'" />

    <!-- Talking With Modal-->
    <div
      :class="['modal', 'fade', this.modal == 'talking' ? 'show' : '']"
      :style="{ display: this.modal == 'talking' ? 'block' : 'none' }"
      id="talkingWithModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="talkingWithModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title d-inline" id="talkingWithModalLabel" v-html="talkingModalTitle">
              
            </h5>
            <p class="text-primary stopwatch">{{formattedElapsedTime}}</p>
            <button
              class="close"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              @click="endCall"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body agents-status" v-if="showTransferLoader">Transferring call...<Loader/></div>
          <div class="modal-body agents-status" v-else>
            <font-awesome-layers class="mr-3">
              <font-awesome-icon
                :icon="['fas', 'user']"
                class="fa-2x text-success"
              />
              <font-awesome-icon
                :icon="['fas', 'phone']"
                class="text-success"
                transform="shrink-6 right-22 up-6"
              />
            </font-awesome-layers>
            <h3 class="d-inline text-success pl-1">{{ callInfo }}</h3>

            <button
              class="btn btn-danger d-inline"
              type="button"
              data-dismiss="modal"
              @click="endCall"
              style="float: right;"
            >
              <font-awesome-layers class="mr-2">
                <font-awesome-icon :icon="['fas', 'user']" class="fa-1x" />
                <font-awesome-icon
                  :icon="['fas', 'phone-slash']"
                  transform="shrink-6 right-16 up-6"
                />
              </font-awesome-layers>
              Finish
            </button>

            <div class="dialpad mb-0 pb-0" :class="{ show: keypad}">
              <div class="row">
                <div class="digit" id="one" @click="sendDigits('1')">1</div>
                <div class="digit" id="two" @click="sendDigits('2')">
                  2
                  <div class="sub">ABC</div>
                </div>
                <div class="digit" id="three" @click="sendDigits('3')">
                  3
                  <div class="sub">DEF</div>
                </div>
              </div>
              <div class="row">
                <div class="digit" id="four" @click="sendDigits('4')">
                  4
                  <div class="sub">GHI</div>
                </div>
                <div class="digit" id="five" @click="sendDigits('5')">
                  5
                  <div class="sub">JKL</div>
                </div>
                <div class="digit" @click="sendDigits('6')">
                  6
                  <div class="sub">MNO</div>
                </div>
              </div>
              <div class="row">
                <div class="digit" @click="sendDigits('7')">
                  7
                  <div class="sub">PQRS</div>
                </div>
                <div class="digit" @click="sendDigits('8')">
                  8
                  <div class="sub">TUV</div>
                </div>
                <div class="digit" @click="sendDigits('9')">
                  9
                  <div class="sub">WXYZ</div>
                </div>
              </div>
              <div class="row">
                <div class="digit" @click="sendDigits('*')">*</div>
                <div class="digit" @click="sendDigits('0')">
                  0
                  <div class="sub plus">+</div>
                </div>
                <div class="digit" @click="sendDigits('#')">#</div>
              </div>
            </div>
          </div>
          <div class="modal-footer agents-calling" v-if="!showTransferLoader">
            <div class="input-group w-auto" v-if="onlineAgents.length > 0">
              <select class="custom-select" v-model="transferAgent" @change="agentSelected()">
                <option disabled value="">----Select Agent-----</option>
                <option v-for="agent in onlineAgents" :value="agent.id" :key="agent.id">{{ agent.name }}</option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-primary" type="button" @click="transferCall()" :disabled="!transferOK">Transfer</button>
              </div>
            </div>
            <button class="btn btn-primary btn-sm" type="button" @click="toggleKeypad()" v-show="call != null">
              <span class="material-icons">dialpad</span> Keypad
            </button>
            <button class="btn btn-primary" type="button" @click="showPayment()" :class="[ this.showPaymentInfo ? 'active': '']" v-if="system && system.paymentEnabled">
              <font-awesome-icon :icon="['fas', 'dollar-sign']"/> <span>Pay</span>
            </button>
            
            <div class="row mt-2 mb-3 payRobot w-100" :style="{ display: this.showPaymentInfo ? 'block' : 'none' }">
              <hr>
              <div class="card col-md-12 p-2">
                <form>

                    <div class="form-row">
                      <div class="col-md-6 mb-3">
                        <label for="crm-id">CRM Id:</label>
                        <input type="text" class="form-control" id="crm-id" v-model="payCRM">
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="amount">Amount:</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="amountPrepend">£</span>
                          </div>
                          <input type="text" class="form-control" id="amount" aria-describedby="amountPrepend" v-model="payAmount">
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                    <div class="col-md-10 mb-3">
                      <label for="concept">Concept:</label>
                      <select class="custom-select" id="concept" v-model="payConcept">
                        <option value="">----Select-----</option>
                        <option value="7">Deposit</option>
                        <option value="4">Balance</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-primary btn-sm btn-pay-ok" type="button" @click="pay()">
                        <font-awesome-icon :icon="['fas', 'dollar-sign']"/> OK
                      </button>
                    </div>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Expiration Notice Modal-->
    <!-- Time Out Modal-->

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DropdownMenu from "@innologica/vue-dropdown-menu";
import Legend from "@/components/Legend"
import AlertNewVersion from '@/components/AlertNewVersion.vue'
import Loader from '@/components/Loader'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { Device } from "@twilio/voice-sdk"
import EventBus from '@/utils/event-bus'
import IncomingCallDialog from '@/components/IncomingCallDialog'

const BROWSER_AUDIO_ACCEPTED_SESSION_KEY = "browserAudioAccepted";

export default {
  name: "System",
  created() {
    if (!this.$appConfig.backendUrl) {
      this.socket = new ReconnectingWebSocket(
        "wss://" + window.location.host + "/api/v1/join?t=" + this.user.token,
        null,
        {debug: false}
      );
    } else {
      this.socket = new ReconnectingWebSocket(
        this.$appConfig.backendUrl + "?t=" + this.user.token,
        null,
        {debug: false}
      );
    }
    this.socket.onopen = function () {
      console.log("Connected");
    };
    this.socket.onerror = function (err) {
      console.log(err);
    };
    this.socket.onclose = function () {
      console.log("Closing websocket");
    };
    this.socket.onmessage = this.processBackendMessage;

    let links = document.getElementsByTagName('link');
    for (let index = 0; index < links.length; index++) {
      const element = links[index];
      let match = element.href.match(/\/js\/app\.(.*?)\.js$/);
      if (match) {
        this.appVersion = match[1];
        break;
      }
    }
  },
  mounted() {
    EventBus.$on('callAgent', this.callAgent);
    EventBus.$on('callNumber', this.callToNumber);
  },
  components: {
    "dropdown-menu": DropdownMenu,
    "legend-menu": Legend,
    "alert-new-version": AlertNewVersion,
    Loader,
    IncomingCallDialog,
  },
  data: () => ({
    available: true,
    socket: null,
    call: null,
    modal: "",
    mics: null,
    showMicSelector: false,
    callNumber: "",
    callType: "",
    outCallNumber: "",
    outNumberPrefix: "",
    keypad: false,
    showPaymentInfo: false,
    transferOK: false,
    transferAgent: "",
    payAmount: 0.0,
    payCRM: "",
    payConcept: "",
    appVersion: "",
    commit: "",
    shouldUpgrade: false,
    showTransferLoader: false,
    outDestinationInfo: '',
    twilioOnline: false,
    elapsedTime: 0,
    timer: undefined,
  }),
  computed: {
    ...mapGetters(["user", "system", "selectedMic", "device"]),
    callFromInfo() {
      return this.call != null ? this.call.parameters.From : "Not Available";
    },
    incomingCallTitle() {
      return this.isInternalCall(this.callFromInfo) ? 'Incoming call from co-worker:' : `Incoming Call for <h5 class="text-primary d-inline font-weight-bold">${this.groupInfo}</h5> from:`
    },
    incomingCallUser() {
      let info = this.callFromInfo;

      if (this.isInternalCall(info)) {
        const id = this.idFromTwilioInfo(info);
        info = this.agentNameFromId(id);
      }

      return info
    },
    incomingCallBody() {
      let body;
      let callType = this.call != null ? this.call.customParameters.get('CallType') : "Undefined";

      if (callType == "PayReturn") {
        let result = this.call.customParameters.get('PayResult');
        let crm = this.call.customParameters.get('PayCRM');
        body = `User finished payment for ${crm} with result: ${result}`;
      }

      return body;
    },
    callInfo() {
      let info = '';

      if (this.callType == "outgoing") {
        info = this.outDestinationInfo;
        if (info[0] != '+') {
          info = this.agentNameFromId(info);
        }
      } else {
        if (this.call != null) {
          info = this.call.parameters.From;
          if (this.isInternalCall(info)) {
            const id = this.idFromTwilioInfo(info);
            info = this.agentNameFromId(id);
          }
        } else {
          info = "Not Available";
        }
      }

      return info;
    },
    talkingModalTitle() {
      if (this.callType == "incoming") {
        const info = this.call != null ? this.call.parameters.From : "Not Available";
        if (this.isInternalCall(info)) {
          return `Call from co-worker. Talking with:`
        } else {
          return `Call for <h5 class="text-primary d-inline font-weight-bold">${this.groupInfo}</h5>. Talking with:`
        }
      } else {
        if (this.outDestinationInfo[0] != '+') {
          return `Call with co-worker. Talking with:`
        } else {
          return `Outside call. Talking with:`
        }
      }
    },
    groupInfo() {
      return this.call != null ? this.call.customParameters.get("GroupName") : "Unknown";
    },
    cleanOutNumber() {
      const extrachars = /[-\s]/g;
      let number = this.callNumber.replace(extrachars, "");
      let isItalyNumber = this.outNumberPrefix == '+39';

      if (!isItalyNumber && number[0] == "0") {
        number = number.substring(1);
      }

      return this.outNumberPrefix + number;
    },
    isValidCallNumber() {
      if (this.outNumberPrefix == "+44") {
        return /^(\d{9,10})$/.test(this.cleanOutNumber.substring(3));
      }
      else {
        return this.cleanOutNumber.length > 5;
      }
      
    },
    outNumbers() {
      if (this.system != null) {
        return this.system.outnumbers;
      }
      return [];
    },
    onlineAgents() {
      if (!this.system || !this.system.agents) {
        return [];
      }

      var agents = this.system.agents.filter(agent => agent.status == 'online' && agent.name != this.user.name);
      agents = agents.sort((a,b) => a.name.localeCompare(b.name));
      return agents;
    },
    /* StopWatch */
    formattedElapsedTime() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    }
  },
  watch: {
    system(newValue) {
      if (newValue != null) {
        this.outCallNumber = newValue.outnumbers[0];
        const localCountries = newValue.countries.filter(item => item.local);
        this.outNumberPrefix = localCountries.length > 0 ? localCountries[0].prefix : "";
      }
    },
  },
  methods: {
    ...mapActions(["updateAgents", "updateSystemSettings", "initSystem", "requestTransferCall", "setupTwilioDevice", "checkCrmId", "updateTwilioToken"]),
    isInternalCall(calledInfo) {
      return calledInfo && "client:" == calledInfo.substring(0, 7);
    },
    backendConnOpen() {
      return this.socket != null && this.socket.readyState == WebSocket.OPEN;
    },
    idFromTwilioInfo(info) {
      return info.substring(7);
    },
    agentNameFromId(id) {
      const agent = this.system.agents.find(agent => agent.id == id);
      return agent ? agent.name : '';
    },
    logout() {
      if (this.backendConnOpen) {
        this.sendLogLogout();
        this.socket.close();
      }
      if (this.device != null) {
        this.device.destroy();
      }
      this.$router.push({ name: "login" }).then(() => {
        this.$store.dispatch("logout");
      });
    },
    validMic(mics, selectedMic) {
      for (let mic of mics) {
        if (mic.device == selectedMic.device) {
          return true;
        }
      }
      return false;
    },
    updateMicOptions() {
      if (this.device != null) {
        var mics = [];
        this.device.audio.availableInputDevices.forEach((d) => {
          mics.push({ label: d.label, device: d.deviceId });
        });
        this.mics = mics;
        if (
          this.selectedMic == null ||
          !this.validMic(mics, this.selectedMic)
        ) {
          this.$store.dispatch("updateSelectedMic", mics[0]);
        }
      }
    },
    selectMic(mic) {
      this.$store.dispatch("updateSelectedMic", mic);
    },
    sendDigits(digit) {
      if (this.call != null) {
        this.call.sendDigits(digit);
      }
    },
    sendTwilioStatusLog(status) {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: status,
          extra: {},
        })
      )
    },
    maybeEnableBrowserAudioOncePerSession() {
      if (window.sessionStorage.getItem(BROWSER_AUDIO_ACCEPTED_SESSION_KEY) === "1") {
        return;
      }

      if (!confirm("Enable browser audio?")) {
        return;
      }

      window.sessionStorage.setItem(BROWSER_AUDIO_ACCEPTED_SESSION_KEY, "1");
      const resumeResult = Device.audioContext.resume();
      if (resumeResult && typeof resumeResult.catch === "function") {
        resumeResult.catch(() => undefined);
      }
    },
    getSpecialNumber() {
      const extrachars = /[-\s]/g;
      let number = this.callNumber.replace(extrachars, "");

      return this.system && this.system.special_numbers && this.system.special_numbers[number];
    },
    callCanceled() {
        this.call = null;
        this.callType = "";
        this.modal = "";
        this.keypad = false;
    },
    async configTwilioDevice() {
      const created = await this.setupTwilioDevice({token: this.system.token, close: true });
      if (created) {
        this.maybeEnableBrowserAudioOncePerSession();
        var _this = this;
        this.device.on("incoming", function (conn) {
          _this.call = conn;
          conn.on("cancel", function() { _this.callCanceled() });
          _this.callType = "incoming";
          _this.modal = "incoming";
          _this.device.audio.setInputDevice(_this.selectedMic["device"]);
        });
        this.device.on("disconnect", function () {
          _this.call = null;
          _this.callType = "";
          _this.modal = "";
          _this.keypad = false;
        });
        this.device.on("deviceChange", function () {
          _this.updateMicOptions();
        });
        this.device.on("unregistered", function() {
          _this.twilioOnline = false;
          _this.sendTwilioStatusLog('offline');
        });
        this.device.on("registered", function() {
          _this.twilioOnline = true;
          _this.sendTwilioStatusLog('online');
        });
        this.device.on("error", function() {});
        this.device.register();
      }
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(() => {
          this.updateMicOptions();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    processBackendMessage(msg) {
      try {
        let data = JSON.parse(msg.data);
        switch (data.type) {
          case "status":
            this.updateAgents(data.value);
            break;
          case "setup":
            this.initSystem(data.value).then(() => {
              this.configTwilioDevice().then(() => {
                let that = this;
                setTimeout(that.renewTwilioToken, this.system.tokenTimeout*1000);
              });
            });
            break;
          case "system_update":
            this.updateSystemSettings(data.value);
            break;
          case "app_version":
            this.commit = data.value.commit;
            this.shouldUpgrade = (data.value.version != "-1" && data.value.version != this.appVersion);
            break;
          case "renew-twilio-token":
            this.setupTwilioDevice({token: data.value, close: true }).then(() => {
              this.updateTwilioToken(data.value).then(() => {
                let that = this;
                setTimeout(that.renewTwilioToken, this.system.tokenTimeout*1000);
              });
            });
            break;
          default:
            console.log("unknown msg: " + msg.data);
        }
      } catch {
        console.log("Msg is not json: " + msg);
      }
    },
    setAvailability() {
      if (this.backendConnOpen) {
        this.sendLogAvailability();
      }
      if (!this.available) {
        if (this.device != null) {
          this.device.destroy();
        }
      } else {
        this.configTwilioDevice();
      }
    },
    startCall() {
      let special = this.getSpecialNumber();
      if (special) {
        alert('This number can not be contacted, it is interpreted by the system as: ' + special);
        return
      }

      if (this.device != null && this.device != undefined) {
        let params = {
          phoneNumber: this.cleanOutNumber,
          agent: this.user.username,
          callerId: this.outCallNumber,
          callType: "phone-call"
        };
        this.startOutboundCall(params);
      }
    },
    callDisconected() {
      this.modal = "";
      this.showTransferLoader = false;
      this.sendLogEndCall();
      clearInterval(this.timer); /* Stop stopwatch */
      this.elapsedTime = 0;      /* Reset stopwatch */
    },
    startOutboundCall(params) {
      this.callType = "outgoing";
      this.call = this.device.connect(params);
      this.call.on('disconnect', this.callDisconected);
      this.outDestinationInfo = params.phoneNumber;
      this.modal = "talking";
      this.timer = setInterval(() => {
        if (this.call != undefined && this.call.status() == "open") {
          this.elapsedTime += 1000;
        }
      }, 1000); /* Start stopwatch */
    },
    acceptCall() {
      this.timer = setInterval(() => {
        this.elapsedTime += 1000;
      }, 1000); /* Start stopwatch */
      if (this.call != null) {
        this.call.accept();
        this.call.on('disconnect', this.callDisconected);
        this.sendLogAcceptCall();
      }
      this.modal = "talking";
    },
    rejectCall() {
      if (this.call != null) {
        this.sendLogRejectCall();
        this.call.reject();
      }
      this.modal = "";
    },
    endCall() {
      if (this.device != null) {
        console.log("disconnecting");
        this.device.disconnectAll();
      }
    },
    toggleKeypad() {
      this.keypad = !this.keypad;
    },
    sendLogLogout() {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: "logout",
          extra: {},
        })
      );
    },
    sendLogAvailability() {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: this.available ? "enable" : "disable",
          extra: {},
        })
      );
    },
    sendLogAcceptCall() {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: "accept-call",
          extra: {
            from: this.call.parameters.From,
            to: this.call.customParameters.get("OriginalNumber"),
          },
        })
      );
    },
    sendLogRejectCall() {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: "reject-call",
          extra: {
            from: this.call.parameters.From,
            to: this.call.customParameters.get("OriginalNumber"),
          },
        })
      );
    },
    renewTwilioToken() {
      this.socket.send(
        JSON.stringify({
          type: "activity",
          value: "renew-twilio-token",
          extra: {},
        })
      );
    },
    sendLogEndCall() {
      this.socket.send(
        JSON.stringify({
          type: "log",
          value: "end-call",
          extra: {
            type: this.callType,
            from: this.callType == "incoming" ? this.call.parameters.From : "",
            to:
              this.callType == "incoming"
                ? this.call.customParameters.get("OriginalNumber")
                : this.call.parameters.phoneNumber,
          },
        })
      );
    },
    clearPaymentInfo() {
      this.payAmount = 0.0;
      this.payCRM = "";
      this.payConcept = "";
    },
    showPayment() {
      this.showPaymentInfo = !this.showPaymentInfo;
      if (!this.showPaymentInfo) {
        this.clearPaymentInfo()
      }
    },
    async pay() {
      if (parseFloat(this.payAmount) <= 0) {
        alert('You must specifiy a valid amount for the payment');
        return;
      }

      if (this.payCRM.trim() == "") {
        alert('You must specifiy a CRM Id');
        return;
      }

      if (this.payConcept == "") {
        alert('You must specifiy the payment concept');
        return;
      }

      this.showTransferLoader = true;

      let crmCheckResult = await this.checkCrmId(this.payCRM);

      if (crmCheckResult == 404) {
        alert("Error 1235: Invalid CRM Id. Id does not exist");
        this.showTransferLoader = false;
        return;
      }

      if (crmCheckResult != 200) {
        alert("Unable to check CRM Id");
        this.showTransferLoader = false;
        return;
      }

      let payload =  {
        'type': 'payment',
        'amount': this.payAmount,
        'crm': this.payCRM,
        'concept': this.payConcept,
        'callSid': this.call.parameters.CallSid,
        'agent': this.user.username
      };

      var req = await this.requestTransferCall(payload);
      if (req.result == 'KO') {
        alert(req.msg);
      } else {
        alert('Transfer successfull');
        this.modal = "";
        this.showPaymentInfo = false;
        this.clearPaymentInfo();
      }

      this.showTransferLoader = false;
    },
    agentSelected () {
      this.transferOK = this.transferAgent != "";
    },
    async transferCall() {
      if (this.transferAgent == "") {
          alert('Please select a destination');
          return;
      }

      let payload = {
        'type': 'agent',
        'agent_id': this.transferAgent,
        'callSid': this.call.parameters.CallSid
      };

      this.showTransferLoader = true;

      var req = await this.requestTransferCall(payload);
      if (req.result == 'KO') {
        alert(req.msg);
      } else {
        alert('Transfer successfull');
        this.transferAgent = "";
      }

      this.showTransferLoader = false;
    },
    callAgent(to) {
      if (this.device != null && this.device != undefined) {
        let params = {
          phoneNumber: to,
          agent: this.user.username,
          callerId: `client:${this.user.username}`,
          callType: "inter-agent",
        };
        this.startOutboundCall(params);
      }
    },
    callToNumber(to) {
      if (this.device != null && this.device != undefined) {
        let params = {
          phoneNumber: to,
          agent: this.user.username,
          callerId: this.outCallNumber,
          callType: "phone-call"
        };
        this.startOutboundCall(params);
      }
    }
  },
};
</script>

<style scoped>
a.dropdown-item {
  white-space: normal;
  padding: 0.25rem 0.25rem 0.25rem 0.75rem;
}

.dialpad {
    background-color: white;
    width: 320px;
    padding: 20px;
    margin: 30px auto;
    height: 395px;
    text-align: center;
    border-top: .25rem solid #4e73df !important;
    border-radius: 4px;
    display: none;
  }

  .dialpad .row {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
  }

  .digit,
  .dig {
    float: left;
    padding: 10px;
    width: 90px;
    font-size: 2rem;
    cursor: pointer;
  }

  .sub {
    font-size: 0.8rem;
    color: grey;
  }

  .botrow {
    margin: 0 auto;
    width: 80px;
    clear: both;
    text-align: center;
  }

  .digit:active,
  .dig:active,
  .botrow:active {
    background-color: #e6e6e6;
  }

  .dig {
    float: left;
    padding: 10px 20px;
    margin: 10px;
    width: 30px;
    cursor: pointer;
  }

  .plus {
    font-size: 18px;
    cursor: pointer;
  }

  .show {
    display: block!important;
  }

  .agents-calling .material-icons {
    vertical-align: bottom;
  }

  .agents-calling .btn-sm {
    padding: .35rem .5rem!important;
  }

  .agents-calling .btn-danger.btn-sm {
    padding: .45rem .5rem!important;
  }
</style>
